import { useState } from "react";
import { Modal } from "@mui/material";
import { Box, IconButton } from "@mui/material";

import { Media } from "../../../../types/types";
import { formatMediaUrl } from "../../../../utils/formatters/formatMedia";

import { VideoPlayButtonIcon } from "../../assets/icons/service-details-icons";

const VideoSection = ({ media }: { media: Media }) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const handleOpenVideoModal = () => setIsVideoModalOpen(true);
  const handleCloseVideoModal = () => setIsVideoModalOpen(false);

  return (
    <Box sx={styles.videoThumbnailContainer}>
      <Box component="img" src={formatMediaUrl(media.thumbnail)} sx={styles.videoThumbnail} />
      <IconButton onClick={handleOpenVideoModal} size="small" sx={styles.videoPlayButton}>
        <VideoPlayButtonIcon />
      </IconButton>
      <VideoModal video={media} open={isVideoModalOpen} onClose={handleCloseVideoModal} />
    </Box>
  );
};

export default VideoSection;

const VideoModal = ({ video, open, onClose }: { video: Media; open: boolean; onClose: () => void }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.videoModal}>
        <Box component="video" controls src={formatMediaUrl(video.url)} sx={styles.videoModalThumbnail} />
      </Box>
    </Modal>
  );
};

const styles = {
  videoThumbnailContainer: {
    width: "100%",
    aspectRatio: "16/9",
    borderRadius: "6px 6px 0px 0px",
    border: "0px solid #BCC1CA",
    overflow: "hidden",
    position: "relative",
  },
  videoThumbnail: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  videoPlayButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  videoModalThumbnail: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  videoModal: {
    width: "1024px",
    height: "700px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "#FFF",
    borderRadius: "12px ",
    overflow: "auto",
    display: "flex",
  },
};
